import script from "./DvLogoComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DvLogoComponent.vue?vue&type=script&setup=true&lang=ts"

import "./DvLogoComponent.vue?vue&type=style&index=0&id=3add08fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3add08fe"]])

export default __exports__